



















































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Event } from "@/types";
import EventModal from "@/components/Event/EventModal.vue";
import EventCard from "@/components/Event/EventCard.vue";
import { mapPreferences } from "vue-preferences";
import MugenScroll from "vue-mugen-scroll";
import axios from "@/plugins/axios";
import moment from "moment";
import { mapGetters } from "vuex";

@Component({
  components: { EventCard, EventModal, MugenScroll },
  computed: {
    ...mapPreferences({ ampm: { defaultValue: true } }),
    ...mapGetters(["isLoggedIn", "isAdmin"])
  }
})
export default class Schedule extends Vue {
  ampm!: boolean;
  events: Event[] = [];
  loading = false;
  width = 350;
  history = false;
  intervals: { update: number } = { update: 0 };
  page = 0;
  endPage = false;

  mounted() {
    this.getSchedule();
    this.onResize();
    this.intervals.update = setInterval(this.getSchedule, 1000 * 60 * 60);
  }

  beforeDestroy() {
    clearInterval(this.intervals.update);
  }

  onResize() {
    this.width = document.documentElement.clientWidth;
  }

  getNext() {
    if (this.events.length > 0 && !this.endPage) {
      this.page += 1;
      this.getSchedule(true);
    }
  }

  @Watch("history")
  resetPage() {
    this.page = 0;
    this.getSchedule();
  }

  getSchedule(next = false) {
    this.loading = true;
    this.endPage = false;
    return axios
      .get("/api/schedule", {
        params: {
          history: this.history ? "true" : undefined,
          full: next ? undefined : "true",
          page: this.page
        }
      })
      .then(async response => {
        const events: Event[] = response.data;
        for (const event of events) {
          if (event) {
            event.start = moment(event.start);
            event.end = moment(event.end);
          }
        }
        if (events.length === 0) {
          this.endPage = true;
        }
        if (next) {
          this.events = this.events.concat(events);
        } else {
          this.events = events;
        }
        this.loading = false;
      });
  }
}
